import { CardBody } from '@chakra-ui/react';
import type { ReactNode } from 'react';

import { ChartHeader, ChartHeaderTitle } from '../ChartHeader';
import { ChartCard, type ChartProps } from '../ChartRoot/Chart';

type ReportTableCardProps = Pick<ChartProps, 'onClick'> & {
  title?: string | null;
  children: ReactNode;
};

export const ReportTableCard = ({
  title,
  onClick,
  children,
}: ReportTableCardProps) => (
  <ChartCard
    onClick={onClick}
    position="relative"
    boxShadow="none"
    border="none"
    borderRadius="0"
  >
    {title && (
      <ChartHeader
        paddingLeft="0.4em"
        paddingRight="0"
        gap="0"
        fontSize="1rem"
        lineHeight="44px"
      >
        <ChartHeaderTitle>{title}</ChartHeaderTitle>
      </ChartHeader>
    )}
    <CardBody
      data-testid="card-body"
      padding="0"
      height={title ? 'calc(100% - 44px)' : '100%'}
    >
      {children}
    </CardBody>
  </ChartCard>
);
